import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseConfig";

// Keep this allowlist small. Free-form chat, feedback, file names, URLs and raw
// server errors can contain personal information and must stay out of GA.
const FIELDS = new Set([
  "builder_id", "tab", "chat_id", "run_id", "layer_id", "layer_type",
  "config_type", "config_name", "analysis_type", "overlay", "enabled",
  "time_seconds", "duration_ms", "message_length", "file_type", "file_size_bytes",
  "endpoint", "error_code", "http_status", "request_id", "status", "source",
]);

function safeValue(key, value) {
  if (value == null || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "boolean") return value ? 1 : 0;
  if (typeof value !== "string") return null;
  // Identifiers are useful for debugging, but never send URL-like values.
  if (key !== "error_code" && /[@/?#\s]/.test(value)) return null;
  return value.slice(0, key === "builder_id" ? 100 : 80);
}

export function trackBuilderEvent(name, details = {}) {
  try {
    if (!/^builder_[a-z0-9_]{1,32}$/.test(name)) return;
    const params = {};
    Object.entries(details || {}).forEach(([key, value]) => {
      if (!FIELDS.has(key)) return;
      const safe = safeValue(key, value);
      if (safe !== null) params[key] = safe;
    });
    logEvent(analytics, name, params);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.warn("Builder analytics unavailable", error);
  }
}

export function trackBuilderFailure(name, details = {}, error) {
  try {
    const rawCode = String(error?.code || "");
    const status = Number(error?.status || error?.response?.status || 0);
    const code = /^[a-zA-Z0-9_/-]{1,60}$/.test(rawCode) ? rawCode : "unknown";
    const requestId = String(error?.requestId || error?.request_id || "");
    trackBuilderEvent(name, {
      ...details,
      error_code: code,
      ...(status >= 100 && status <= 599 ? { http_status: status } : {}),
      ...(requestId ? { request_id: requestId } : {}),
    });
  } catch (trackingError) {
    if (process.env.NODE_ENV !== "production") console.warn("Builder analytics unavailable", trackingError);
  }
}
